module.exports = __webpack_public_path__ + "static/media/photo20.0684a4e5.jpg";